import { Skeleton } from '@mui/material'

const SkeletonAddress = () => {
  return <Skeleton sx={{ width: '400px' }} />
}

export default SkeletonAddress
